import React from 'react';
import { connect } from 'react-redux'
import Title from 'react-document-title';

import Header from 'components/header';
import NotificationPanel from 'components/notification/panel';

import { getUser } from 'actioncreators/user';
import { getGlobalImage } from 'util/window';

// const cropRegex = /\/image\/[\d+]{1,}\/crop.*/g;

export class App extends React.Component {

  constructor(props) {
    super(props);
  }

  componentDidMount() {
    window.addEventListener('message', this.receiveMessage);
    this.props.getUser();
  }

  componentWillUnmount() {
    window.removeEventListener('message', this.receiveMessage);
  }

  sendMessage(event) {
    const img = getGlobalImage();
    if(img === null) {
        return;
    } else {
        event.source.postMessage(JSON.stringify(img), event.origin);
        window.close();
    }
  }

  receiveMessage(event) {
    if (event.data === '--GET--') {
      const img = getGlobalImage();
      if(img === null) {
        return;
      } else {
        event.source.postMessage(JSON.stringify(img), event.origin);
        window.close();
      }
    }
    if (__SETUP__ === 'scroll') {
      try {
        const articleData = JSON.parse(event.data);
        if (!articleData['SETDATA']) {
          return;
        }
        window.articleMeta = articleData['SETDATA'];
      } catch (e) {
        console.log(e);
      }
    }
  }

  renderLoggedOutUser() {
    const { user, notifications } = this.props;
    const { checking, checked, loggedIn } = user;
    let message = <a href={user.loginURL} className="c-btn">Checking Login</a>;
    if (checking) {
      message = <div className="c-loader" />;
    } else if (checked && !loggedIn) {
      message = <a href={user.loginURL} className="c-btn">Please Login</a>;
    }
    return (
      <Title title="Please login">
        <div className="container no-login">
          <div className="container">
            {message}
          </div>
          <NotificationPanel
            notifications={notifications} />
        </div>
      </Title>
    );
  }

  render() {
    const props = this.props;
    const { user, pathname } = props;
    if (!user.loggedIn) {
      return this.renderLoggedOutUser();
    }
    return (
      <Title title="Loading...">
        <div>
          <Header query={props.searchQuery} />
          <div className="container">{props.children}</div>
          <NotificationPanel
            notifications={props.notifications} />
        </div>
      </Title>
    );
  } 
}

const mapStateToProps = ({ notifications, user }, ownProps) => {
  return {
    user,
    notifications,
    searchQuery: ownProps.location.query || {},
    pathname: ownProps.location.pathname
  };
};
const mapDispatchToProps = (dispatch) => ({
  getUser: () => dispatch(getUser()),
});

const MainApp = connect(
  mapStateToProps,
  mapDispatchToProps
)(App)

export default MainApp;



/** WEBPACK FOOTER **
 ** ./app/index.js
 **/